import React, { useContext } from 'react';
import { UsuariosContext } from '../../../contexts/usuariosProvider';
import { UserContext } from '../../../contexts/userProvider';
import DataTable from '../../Table';
import Loader from '../../Loader/load';

const nivelLabels = {
  '1': 'Básico',
  '2': 'Gerente',
  '3': 'Admin',
};

const Consulta = ({ onTabChange }) => {
  const { usuarios, loading, toggleStatusUsuario, setUsuarioEdit } = useContext(UsuariosContext);
  const { isAdmin } = useContext(UserContext);
  const { setAlert, user } = useContext(UserContext);

  const headers = [
    {
      label: 'Nome',
      key: 'name',
      sortable: true,
      width: 'w-2/6',
      truncate: true
    },
    {
      label: 'Email',
      key: 'email',
      sortable: true,
      width: 'w-2/6',
    },
    {
      label: 'Nível',
      key: 'nivel',
      sortable: true,
      width: 'w-1/6',
      render: (item) => {
        const colors = {
          '1': 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
          '2': 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300',
          '3': 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300',
        };
        return (
          <span className={`px-2 py-1 rounded-full text-xs font-semibold ${colors[item.nivel] || colors['1']}`}>
            {nivelLabels[item.nivel] || item.nivel}
          </span>
        );
      }
    },
    {
      label: 'Status',
      key: 'ativo',
      sortable: true,
      width: 'w-1/6',
      render: (item) => {
        const isAtivo = Number(item.ativo) === 1;
        return (
          <div className="flex items-center gap-2">
            <span
              className={`px-2 py-1 rounded-full text-xs font-semibold ${
                isAtivo ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300'
                        : 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300'
              }`}
            >
              {isAtivo ? 'Ativo' : 'Inativo'}
            </span>
            <button
              type="button"
              onClick={() => toggleAtivo(item.id)}
              className={`px-2.5 py-1 rounded-lg text-xs font-semibold text-white transition-colors ${
                isAtivo ? 'bg-red-500 hover:bg-red-600' : 'bg-green-600 hover:bg-green-700'
              }`}
            >
              {isAtivo ? 'Desativar' : 'Ativar'}
            </button>
          </div>
        );
      }
    },
    {
      label: 'Ações',
      key: 'actions',
      sortable: false,
      width: 'w-1/6',
      actions: {
        // Editar (inclui NÍVEL) é só admin; gerente só ativa/desativa.
        ...(isAdmin ? { "editar": editarUsuario } : {}),
      }
    },
  ];

  function editarUsuario(id) {
    const usuario = usuarios.find((u) => u.id === id);
    setUsuarioEdit(usuario);
    onTabChange('cadastro');
  }

  function toggleAtivo(id) {
    const usuario = usuarios.find((u) => u.id === id);
    if (!usuario) return;

    if (usuario.id === user.id) {
      setAlert({
        visible: true,
        title: "Atenção!",
        placeholder: "Não é possível desativar seu próprio usuário",
        confirm: false,
        type: "warning",
      });
      return;
    }

    const isAtivo = Number(usuario.ativo) === 1;
    const statusLabel = isAtivo ? 'desativar' : 'ativar';
    setAlert({
      type: 'confirm',
      placeholder: `Deseja ${statusLabel} o usuário "${usuario.name}"?`,
      visible: true,
      confirm: true,
      title: 'Atenção!',
      callback: () => toggleStatusUsuario(id),
    });
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="usuarios-consulta-container">
          {usuarios && usuarios.length > 0 ? (
            <DataTable data={usuarios} headers={headers} itemsPerPage={10} />
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <div className="text-gray-400 mb-4">
                <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Nenhum usuário encontrado
              </h3>
              <p className="text-gray-500 dark:text-gray-400 max-w-sm">
                Cadastre um novo usuário na aba "Cadastro".
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Consulta;
